import { Map } from 'immutable';
import moment from 'moment';
import { dispatch } from 'nike-re-framejs';

import { currencyFormat } from 'nike-ui/src/common/util';
import i18n from '@i18n';
import { isString } from '@/common/util';

export const CURRENCY_MAP = Map({
    EUR: '\u20ac',
    NIK: 'NIK',
    //lebo premyslanie je komplikovane...
    Bodov: 'NIK',
    TOURNAMENT_POINTS: 'b'
});

export const BETSLIP_TYPES = {
    standard: 'Standard',
    system: 'System'
};

const BOARD_BETSLIP_ERRORS = [
    'BET_EXCLUSION_ERROR',
    'BET_EXPIRATION_TIME_ERROR',
    'BET_EVENT_EXCLUSION_ERROR',
    'ERROR_SERVER',
    'LOGIN_ERROR'
];

export function isScoreboardError(errType) {
    return BOARD_BETSLIP_ERRORS.includes(errType);
}

export function handle(callback) {
    return e => {
        e.preventDefault();
        e.stopPropagation();

        callback(e);
    };
}

export function handleDispatch(cmd) {
    return handle(() => dispatch(cmd));
}

export function formatOdds(odds) {
    if (odds === 0 || odds === 1) {
        return odds.toFixed(0);
    }
    return odds.toFixed(2);
}

export function formatMoney(money, currency, decPlaces, roundDown = false) {
    if (typeof money === 'undefined' || money === null) {
        return null;
    }

    if (currency) {
        return `${currencyFormat(money, decPlaces, roundDown)}\u00A0${CURRENCY_MAP.get(currency)}`;
    }
    const value = money.get ? money.get('money') : money.money;
    const cur = money.get ? money.get('currency') : money.currency;

    return formatMoney(value, cur);
}

export function formatCurrency(currency) {
    if (typeof currency === 'undefined') {
        return null;
    }
    return `${CURRENCY_MAP.get(currency)}`;
}

const today = moment();
const yesterday = moment().subtract(1, 'day');
const tomorrow = moment().add(1, 'day');

export function isToday(date) {
    return date.isSame(today, 'day');
}

function isYesterday(date) {
    return date.isSame(yesterday, 'day');
}

export function isTomorrow(date) {
    return date.isSame(tomorrow, 'day');
}

export function formatDateOverview(date) {
    const momentDate = moment(date);
    if (!momentDate.isValid()) {
        return isString(date) ? date : '';
    }
    let hours = momentDate.format('HH:mm');
    if (isToday(momentDate)) {
        return i18n('jsp.homepage.datum.dnes') + ' - ' + hours;
    }
    return momentDate.format('DD.MM.YYYY') + ' - ' + hours;
}

export function formatTicketDetailDate(date) {
    const momentDate = moment(date);
    if (isToday(momentDate)) {
        return firstToUpperCase(i18n('commons.datum.dnes') + ' ' + momentDate.format('H:mm'));
    }
    if (isYesterday(momentDate)) {
        return firstToUpperCase(i18n('enum.calendar.vcera') + ' ' + momentDate.format('H:mm'));
    }
    return momentDate.format('D. M. H:mm');
}

export function scrollBody(param) {
    if (param === false) {
        document.getElementsByTagName('body')[0].className = 'body-no-scroll';
        document.getElementsByTagName('html')[0].className = 'html-no-scroll';
    } else {
        document.getElementsByTagName('body')[0].className = 'body-yes-scroll';
        document.getElementsByTagName('html')[0].className = 'html-yes-scroll';
    }
}

export function scrollBodyPopup(param) {
    if (param === false) {
        document.getElementsByTagName('body')[0].classList.add('body-no-scroll-popup');
    } else {
        document.getElementsByTagName('body')[0].classList.remove('body-no-scroll-popup');
    }
}

export class ScrollMixin {}

ScrollMixin.block = {
    componentDidMount() {
        scrollBody(false);
    },
    componentWillUnmount() {
        scrollBody(true);
    }
};

ScrollMixin.blockPopup = {
    componentDidMount() {
        scrollBodyPopup(false);
    },
    componentWillUnmount() {
        scrollBodyPopup(true);
    }
};

export function sendUsingForm(path, params, method) {
    let form = document.createElement('form');
    form.setAttribute('method', method || 'post');
    form.setAttribute('action', path);
    for (let key in params) {
        if (params.hasOwnProperty(key)) {
            let hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', key);
            hiddenField.setAttribute('value', params[key]);

            form.appendChild(hiddenField);
        }
    }
    document.body.appendChild(form);
    form.submit();
}

export function formatDate(date) {
    const momentDate = moment(date);
    if (isToday(momentDate)) {
        return i18n('commons.datum.dnes') + ' ' + momentDate.format('D. M. YYYY');
    }
    if (isTomorrow(momentDate)) {
        return i18n('commons.datum.zajtra') + ' ' + momentDate.format('D. M. YYYY');
    }
    return momentDate.format('dddd D. M. YYYY');
}

export function todayYesterdayOr(date, orFormat) {
    const momentDate = moment(date);
    if (isToday(momentDate)) {
        return i18n('commons.datum.dnes');
    }
    if (isYesterday(momentDate)) {
        return i18n('enum.calendar.vcera');
    }
    return momentDate.format(orFormat);
}

export function firstToUpperCase(str) {
    if (!str) {
        return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function dateIsToday(date) {
    return (
        moment()
            .startOf('date')
            .valueOf() ===
        moment(date)
            .startOf('date')
            .valueOf()
    );
}

export function getDayFromDate(date) {
    return moment(date).get('date');
}

export function goToHomePage() {
    window.location.href = '/';
}

export const replaceNonAlpaNumeric = (text, replaceWith = '') => text.replace(/[\W_]+/g, replaceWith);
